import { render, staticRenderFns } from "./approvalRoles.vue?vue&type=template&id=487fa1bc"
import script from "./approvalRoles.vue?vue&type=script&lang=js"
export * from "./approvalRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports